const { create } = require('axios');

const BASE_URL = process.env.REACT_APP_WEBFORM_URL;

export const axiosInterceptor = create({
    baseURL: BASE_URL
});

axiosInterceptor.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem('diologAuthToken');
        config.headers['Authorization'] = token;
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);
